<script>
    export let height = 40;
</script>
<div class="text-center border-bottom border-secondary d-flex align-items-center justify-content-center" style="height: {height}px; font-size: 1vw">
    <i class="bi bi-soundwave" /> 
 </div>